export const ROLES_DISPLAY = {
  ROLE_USER: 'Collaborateur',
  ROLE_CONCIERGE: 'Concierge',
  ROLE_COMPANY_MANAGER: 'Administrateur',
};